<ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" [attr.aria-label]="gridAriaLabel"></ag-grid-angular>